import { render } from "./drawer.vue?vue&type=template&id=6c662847"
import script from "./drawer.vue?vue&type=script&lang=js"
export * from "./drawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__